import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";
const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const ourClientSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  slug: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .matches(SLUG_PATTERN, {
      message: "Slug may only contain lowercase letters, numbers, and hyphens",
      excludeEmptyString: true,
    }),
  shortDescription: yup.string().nullable(),
  fullDescription: yup.string().nullable(),
  websiteUrl: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .url("Please enter a valid URL (e.g. https://example.com)"),
  displayOrder: yup
    .number()
    .typeError("Display order must be a number")
    .min(0, "Display order cannot be negative")
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
});
